<template>
  <div>
    <section class="content">
      <ul v-if="details != ''">
        <li>
          <h2>{{ Number(details.amount) + "元" }}</h2>
        </li>
        <br />
        <li>
          <label>报销编号：</label>
          <p>{{ details.bx_no }}</p>
        </li>
        <br />
        <li v-show="details.no != ''">
          <label>费用编号：</label>
          <p>{{ details.no }}</p>
        </li>
        <br v-show="details.no != ''" />
        <li>
          <label>创建时间：</label>
          <p>{{ details.create_time }}</p>
        </li>
        <br />
        <li>
          <label>费用归属日期：</label>
          <p>
            {{
              details.finance_date != undefined
                ? details.finance_date.substring(0, 10)
                : ""
            }}
          </p>
        </li>
        <br />
        <li>
          <label>项目：</label>
          <p>{{ details.project_name }}</p>
        </li>
        <br />
        <li>
          <label>费用类型：</label>
          <p>{{ details.pname + "-" + details.finance_type_name }}</p>
        </li>
        <br />
        <li>
          <label>状态：</label>
          <p v-show="details.status == 10">待项目经理审核</p>
          <p v-show="details.status == 11">项目经理驳回</p>
          <p v-show="details.status == 20">待项目总监审核</p>
          <p v-show="details.status == 21">项目总监驳回</p>
          <p v-show="details.status == 30 && details.xf_status == 20">
            待项目负责人审核
          </p>
          <p v-show="details.status == 30 && details.xf_status == 21">
            项目负责人驳回
          </p>
          <p v-show="details.status == 30 && details.xf_status == 30">
            待财务审核
          </p>
          <p v-show="details.status == 30 && details.xf_status == 31">
            财务驳回
          </p>
          <p v-show="details.status == 30 && details.xf_status == 40">
            待出纳审核
          </p>
          <p v-show="details.status == 30 && details.xf_status == 41">
            出纳驳回
          </p>
          <p v-show="details.status == 30 && details.xf_status == 42">
            部分打款
          </p>
          <p v-show="details.status == 30 && details.xf_status == 50">
            结算完成
          </p>

          <p v-show="details.status == 30 && details.xf_status == 100">
            已作废
          </p>
        </li>
        <br />
        <!-- <li>
          <label>费用金额：</label>
          <p>{{ Number(details.amount) + "元" }}</p>
        </li> -->
        <li style="width: 80%">
          <label>费用明细：</label>
          <p>{{ details.detail }}</p>
        </li>
        <li>
          <label>打款至：</label>
          <p v-show="details.out_account_type == 1">{{ details.user_name }}</p>
          <p v-show="details.out_account_type == 2">员工</p>
          <p v-show="details.out_account_type == 3">三方</p>
          <p v-show="details.out_account_type == 4">其他</p>
          <p v-show="details.out_account_type == 0">未知</p>
        </li>
        <li>
          <label>结算方式：</label>
          <p v-show="details.paytype == 1">支付宝</p>
          <p v-show="details.paytype == 2">银行卡</p>
        </li>
        <br v-show="details.out_account_type == 3" />
        <li
          v-show="details.out_account_type == 3"
          class="workerStyle thirdStyle"
        >
          <ul>
            <li
              v-if="
                details.third_part_info != undefined &&
                  details.third_part_info != ''
              "
            >
              <div v-show="details.third_part_info.type == 1">
                <label>公司名称：</label>
                <p>{{ details.third_part_info.name }}</p>
              </div>
              <div v-show="details.third_part_info.type == 1">
                <label>公司地址：</label>
                <p>{{ details.third_part_info.company_address }}</p>
              </div>
              <div v-show="details.third_part_info.type == 1">
                <label>纳税人识别号：</label>
                <p>{{ details.third_part_info.taxpayer }}</p>
              </div>
              <div>
                <label>联系人姓名：</label>
                <p>{{ details.third_part_info.contact_name }}</p>
              </div>
              <div>
                <label>联系人手机号：</label>
                <p>{{ details.third_part_info.contact_phone }}</p>
              </div>
              <div v-show="details.third_part_info.type == 2">
                <label>身份证号：</label>
                <p>{{ details.third_part_info.idcard }}</p>
              </div>
              <div>
                <label>银行名称：</label>
                <p>{{ details.third_part_info.bank_name }}</p>
              </div>
              <div>
                <label>支行名称：</label>
                <p>{{ details.third_part_info.bank_branch }}</p>
              </div>
              <div>
                <label>银行账号：</label>
                <p>{{ details.third_part_info.bank_no }}</p>
              </div>
            </li>
          </ul>
        </li>
        <br v-show="details.out_account_type == 4" />
        <li v-show="details.out_account_type == 4" class="workerStyle">
          <label>其他账户信息：</label>
          <p>{{ details.other_info }}</p>
        </li>
        <br />
        <li v-show="accessory != ''" class="accessoryStyle">
          <label>附件：</label>
          <viewer :images="accessory">
            <img
              class="imgStyle"
              v-for="src in accessory"
              :src="src.url"
              :key="src.id"
            />
          </viewer>
        </li>
        <br v-show="details.status == 50 || details.status == 42" />
        <li v-show="details.status == 50 || details.status == 42">
          <label>打款金额：</label>
          <p>{{ Number(details.out_total_amount) + "元" }}</p>
        </li>
        <li v-show="details.status == 50 || details.status == 42">
          <label>出账账户：</label>
          <p>{{ details.company_names }}</p>
        </li>
        <li
          class="fn_clear"
          v-show="
            details.guard_list != '' &&
              (details.finance_type_name == '临时工结算' ||
                details.finance_type_name == '离职/提前结算')
          "
        >
          <label>渠道：</label>
          <p v-show="details.resume_source == 3">自招</p>
          <p v-show="details.resume_source == 4">三方</p>
        </li>
        <li
          class="fn_clear"
          v-show="
            details.guard_list != '' &&
              (details.finance_type_name == '临时工结算' ||
                details.finance_type_name == '离职/提前结算')
          "
        >
          <label>是否包含服务费：</label>
          <p v-show="details.is_service == 1">不包含</p>
          <p v-show="details.is_service == 2">包含</p>
        </li>
        <li
          class="fn_clear"
          v-show="
            details.guard_list != '' &&
              (details.finance_type_name == '临时工结算' ||
                details.finance_type_name == '离职/提前结算')
          "
        >
          <label>甲方单价：</label>
          <p>{{ Number(details.first_price) }}</p>
        </li>
        <li
          class="fn_clear"
          v-show="
            details.guard_list != '' &&
              (details.resume_source == 3 || details.is_service == 1)
          "
        >
          <label>员工单价：</label>
          <p>{{ Number(details.guard_price) }}</p>
        </li>
        <li
          class="fn_clear"
          v-show="
            details.guard_list != '' &&
              (details.resume_source == 4 && details.is_service == 2)
          "
        >
          <label>打包/渠道单价：</label>
          <p>{{ Number(details.pack_price) }}</p>
        </li>
        <li
          class="fn_clear"
          v-show="
            details.guard_list != '' &&
              (details.resume_source == 4 && details.is_service == 1)
          "
        >
          <label>三方单价：</label>
          <p>{{ Number(details.three_price) }}</p>
        </li>
        <li v-show="details.guard_list != ''" class="workerStyle">
          <table>
            <thead>
              <th>员工姓名</th>
              <th>身份证号</th>
              <th>银行名称</th>
              <th>银行卡号</th>
              <th>工时/件数</th>
              <th>结算金额</th>
            </thead>
            <tbody>
              <tr v-for="(item, k) in details.guard_list" :key="k">
                <td>{{ item.name }}</td>
                <td>{{ item.idcard }}</td>
                <td>{{ item.bank_name }}</td>
                <td>{{ item.bank_card_number }}</td>
                <td>{{ item.hours }}</td>
                <td>{{ item.amount }}</td>
              </tr>
            </tbody>
          </table>
        </li>
      </ul>
    </section>
    <section>
      <h3>审核信息</h3>
      <a-steps
        :current="activeStep"
        direction="vertical"
        class="auditStyle"
        size="small"
      >
        <a-step v-for="item in details.sort_check_record" :key="item.id">
          <a-icon
            v-if="item.result_status == 1"
            slot="icon"
            type="check-circle"
            style="color: #67c23a"
          />
          <a-icon
            v-else-if="item.result_status == 2"
            slot="icon"
            type="exclamation-circle"
            style="color: #f56c6c"
          />
          <a-icon
            v-else
            type="question-circle"
            slot="icon"
            style="color: #e6a23c"
          />
          <template slot="title">
            <p v-show="item.record_from_type == 2 && item.to_status == 10">
              提交申请
            </p>
            <p v-show="item.record_from_type == 2 && item.to_status == 11">
              项目经理驳回
            </p>
            <p v-show="item.record_from_type == 2 && item.to_status == 20">
              项目经理审核通过
            </p>
            <p v-show="item.record_from_type == 2 && item.to_status == 21">
              项目总监驳回
            </p>
            <p v-show="item.record_from_type == 2 && item.to_status == 30">
              项目总监审核通过
            </p>
            <p v-show="item.record_from_type == 2 && item.to_status == 31">
              项目总监驳回
            </p>
            <p v-show="item.record_from_type == 1 && item.to_status == 20">
              提交申请
            </p>
            <p v-show="item.record_from_type == 1 && item.to_status == 21">
              项目负责人驳回
            </p>
            <p v-show="item.record_from_type == 1 && item.to_status == 30">
              项目负责人审核通过
            </p>
            <p v-show="item.record_from_type == 1 && item.to_status == 31">
              财务驳回
            </p>
            <p v-show="item.record_from_type == 1 && item.to_status == 40">
              财务审核通过
            </p>
            <p v-show="item.record_from_type == 1 && item.to_status == 41">
              出纳驳回
            </p>
            <p v-show="item.record_from_type == 1 && item.to_status == 50">
              结算完成
            </p>
            <p v-show="item.record_from_type == 1 && item.to_status == 100">
              费用作废
            </p>
          </template>
          <div slot="description" class="description">
            <span>
              <label>{{
                item.check_type == 0 ? "提交人：" : "审核人："
              }}</label>
              <p>
                {{ item.user_name }}
              </p>
            </span>
            <span>
              <label>{{
                item.to_status == 10 ? "申请时间：" : "操作时间："
              }}</label>
              <p>{{ item.create_time }}</p>
            </span>
            <span v-show="item.result_status == 2">
              <label>驳回原因：</label>
              <p>{{ item.reason }}</p>
            </span>
            <!-- <span v-show="details.type == 1 && item.to_status == 40">
              <label>开票日期：</label>
              <p>
                {{
                  item.invoice_date == ""
                    ? ""
                    : item.invoice_date.substring(0, 10)
                }}
              </p>
            </span>
            <br v-show="item.to_status == 50 || item.to_status == 42" /> -->
            <span v-show="item.to_status == 50 || item.to_status == 42">
              <label>{{
                details.type == 1 ? "入职账户：" : "出账账户："
              }}</label>
              <p>{{ item.company_name }}</p>
            </span>
            <span v-show="item.to_status == 50 || item.to_status == 42">
              <label>{{
                details.type == 1 ? "入账金额：" : "出账金额："
              }}</label>
              <p>{{ Number(item.amount) + "元" }}</p>
            </span>
            <span v-show="item.to_status == 50 || item.to_status == 42">
              <label>备注：</label>
              <p>{{ item.remark }}</p>
            </span>
            <span v-show="details.type == 1 && item.to_status == 40">
              <label>开票金额：</label>
              <p>{{ Number(item.invoice_amount) + "元" }}</p>
            </span>
          </div>
        </a-step>
      </a-steps>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      details: {},
      activeStep: 0,
      accessory: []
    };
  },
  props: {
    detailsVal: {}
  },
  watch: {
    detailsVal() {
      this.getDetails();
    }
  },
  mounted() {
    if (this.detailsVal != undefined) {
      this.getDetails();
    }
  },
  methods: {
    getDetails() {
      this.details = this.detailsVal;
      if (this.details.sort_check_record != undefined) {
        this.activeStep = this.details.sort_check_record.length;
      } else {
        this.activeStep = 0;
      }
      if (
        this.details.images_url != undefined &&
        this.details.images_url != ""
      ) {
        this.accessory = this.details.images_url;
      } else {
        this.accessory = [];
      }
    }
  }
};
</script>
<style lang="less" scoped>
h3 {
  font-size: 14px;
  line-height: 20px;
  font-weight: normal;
  margin: 30px 4% 0;
}
h2 {
  font-size: 18px;
  line-height: 20px;
  font-weight: normal;
}
.content {
  margin: 30px 4%;
  > ul {
    > li {
      display: inline-block;
      width: 33.3%;
      margin-bottom: 10px;
      p,
      label {
        display: inline-block;
        font-size: 14px;
        line-height: 18px;
      }
    }
    .workerStyle {
      width: 100%;
      table {
        width: 100%;
        td,
        th {
          border: 1px solid #ccc;
          padding: 8px 12px;
          font-size: 14px;
          line-height: 18px;
          font-weight: normal;
        }
        th {
          background: #ededed;
        }
      }
      > ul {
        > li {
          div {
            display: inline-block;
            width: 33.3%;
            margin-bottom: 10px;
          }
          div:first-child,
          div:nth-child(2) {
            display: block;
          }
        }
      }
    }
    .thirdStyle {
      > ul {
        li {
          div:first-child,
          div:nth-child(2) {
            display: inline-block;
          }
        }
      }
    }
  }

  .accessoryStyle {
    > div {
      display: inline-block;
      width: 60%;
      vertical-align: top;
    }
    img {
      width: 200px;
      height: 200px;
      object-fit: cover;
      border: 1px solid #ededed;
      margin-bottom: 10px;
      margin-left: 10px;
    }
  }
}
</style>
<style lang="less">
.auditStyle {
  margin: 20px 4%;
  .ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-tail::after {
    background-color: rgba(0, 0, 0, 0.45);
    // background-color: #67C23A;
  }
  .description {
    > span {
      margin-right: 20px;
      display: inline-block;
      p,
      label {
        display: inline-block;
      }
    }
  }
}
</style>
